
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[handle]",
      function () {
        return require("private-next-pages/collections/[handle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[handle]"])
      });
    }
  